<label class="form-control-label">
  {{label | translate}}: @if (isRequired) {
  <span class="tx-danger">*</span>
}
</label>
